import Image from 'next/image'
import { FC, Dispatch, SetStateAction } from 'react'
import { IDiamond } from 'types/diamond.types'
import { generateCertUrl, getDiamondLabIcon } from './helper'
import s from './DiamondCert.module.css'
import { Button } from '@components/ui'

interface Props {
  diamond: IDiamond
  setDisplayCertModal: Dispatch<SetStateAction<boolean>>
}

const DiamondCert: FC<Props> = ({ diamond, setDisplayCertModal }) => {
  if (diamond.lab && diamond.certurl_local) {
    if (diamond.has_cert) {
      return (
        <div className={s.icon}>
          <Image
            src={getDiamondLabIcon(diamond.lab)}
            alt={`${diamond.lab.toUpperCase()} certificate`}
            width={96}
            height={96}
          />
          <Button variant="type1" onClick={() => setDisplayCertModal(true)}>
            Tap to view details
          </Button>
        </div>
      )
    } else {
      return (
        <div className={s.icon}>
          <Image
            src={getDiamondLabIcon(diamond.lab)}
            alt={`${diamond.lab.toUpperCase()} certificate`}
            width={96}
            height={96}
          />
          <a
            href={diamond.certurl_local}
            target="_blank"
            rel="noreferrer"
            className={s.certLink}
          >
            Tap to view details
          </a>
        </div>
      )
    }
  } else if (diamond.lab && !diamond.certurl_local) {
    return (
      <div className={s.icon}>
        <Image
          src={getDiamondLabIcon(diamond.lab)}
          alt={`${diamond.lab.toUpperCase()} certificate`}
          width={96}
          height={96}
        />
        <a
          href={generateCertUrl(diamond.lab, diamond.certnum)}
          target="_blank"
          rel="noreferrer"
          className={s.certLink}
        >
          Tap to view details
        </a>
      </div>
    )
  } else {
    return null
  }
}

export default DiamondCert
